export class FaxContact {
  constructor(
    public name: string,
    public fax: string,
    public postalAddress,
    public type: string
  ) {}
}
